const l = {
  name: "SettingsFilled",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M9.6,0.2L10,1c0.4,0.8,1.1,1.3,2,1.3c0.9,0,1.6-0.5,2-1.3l0.4-0.7l0.8,0.2c2,0.5,3.8,1.6,5.2,3L21,4l-0.4,0.7
			c-0.5,0.7-0.5,1.6-0.1,2.4l0,0c0.4,0.8,1.3,1.2,2.1,1.1l0.8,0L23.6,9c0.2,1,0.4,2,0.4,3s-0.2,2.1-0.4,3l-0.2,0.8l-0.8,0
			c-0.8,0-1.7,0.4-2.1,1.1c-0.4,0.8-0.4,1.7,0.1,2.4L21,20l-0.6,0.6c-1.4,1.4-3.2,2.5-5.2,3l-0.8,0.2L14,23.1
			c-0.4-0.8-1.1-1.3-2-1.3c-0.9,0-1.6,0.5-2,1.3l-0.4,0.7l-0.8-0.2c-2-0.5-3.8-1.6-5.2-3L3,20l0.4-0.7c0.5-0.7,0.5-1.6,0.1-2.4l0,0
			c-0.4-0.8-1.3-1.2-2.1-1.1l-0.8,0L0.4,15c-0.2-1-0.4-2-0.4-3s0.2-2.1,0.4-3l0.2-0.8l0.8,0c0.8,0,1.7-0.4,2.1-1.1
			C4,6.3,3.9,5.4,3.4,4.7L3,4l0.6-0.6C5,2,6.8,1,8.8,0.5L9.6,0.2z M8,12c0,2.2,1.8,4,4,4c2.2,0,4-1.8,4-4c0-2.2-1.8-4-4-4
			C9.8,8,8,9.8,8,12z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as SettingsFilled
};
